

























































































































































































































































































import { GetExeImg, UploadFile } from "../request";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { caijiMixin } from "./take-photos-video/caijiMixin";
import { getLevelOptions } from "../common";
import SubTitle from "./title-sub.vue";
import Title from "./title.vue";
@Component({
  components: {
    Title,
    SubTitle,
  },
})
export default class Name extends mixins(caijiMixin) {
  @Prop()
  private content: any; // 整个content数据
  @Watch("content", { immediate: true })
  private contentChange() {
    if (this.content) {
      this.cContent = JSON.parse(JSON.stringify(this.content));
      if (!this.cContent.report["面象信息"]) {
        this.cContent.report["面象信息"] = {
          面色: [],
          唇态: ["润"],
          唇色: [],
          鼻光泽: ["有光泽"],
          鼻形态: ["正常"],
          鼻颜色: ["正常肤"],
          人中形态: ["短浅"],
          人中颜色: ["正常肤色"],
        };
        // 转格式,填充数据
        const oldData: any = this.cContent.report["面象信息输出"];
        // 面色
        if (oldData[0]) {
          const text: any = oldData[0];
          this.cContent.report["面象信息"]["面色"].push(text);
        }
        if (oldData[1] && oldData[1] == "有") {
          this.cContent.report["面象信息"]["面色"].push("两颧红");
        }
        if (oldData[2] && oldData[2] == "有") {
          this.cContent.report["面象信息"]["面色"].push("眼眶黑");
        }
        if (oldData[3]) {
          const text: any = oldData[3];
          this.cContent.report["面象信息"]["面色"].push(text);
        }

        // 唇色
        if (oldData[4]) {
          const text: any = oldData[4];
          this.cContent.report["面象信息"]["唇色"].push(text);
        }
        this.$emit("updateContent", JSON.parse(JSON.stringify(this.cContent)));
        setTimeout(() => {
          // 保存
          this.$emit("save");
        }, 200);
        this.$forceUpdate();
      }
    }
  }
  @Prop()
  private index: any; // 当前题目的索引
  @Prop()
  private data: any; // 题目的数据
  @Watch("data", { immediate: true })
  private dataChange() {
    if (this.data) {
      this.c = JSON.parse(JSON.stringify(this.data));
      if (!this.c.value) {
        this.c.value = {
          imgs: [],
        };
      }
    }
  }
  @Prop()
  private source: any; //dialog,审核修改弹框;renkouxue,人口学和受试者信息;
  private getLevelOptions(type: any, key: any, level: any) {
    return getLevelOptions(type, key, level);
  }
  /**
   * @param val <string array>
   */
  private getShowContent(val: any) {
    let result: any = "";
    if (val && val.length > 0) {
      result = val.join("、");
    }
    return result;
  }
}
